"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tweet = Tweet;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _swr = _interopRequireDefault(require("swr"));

var _twitterLogo = _interopRequireDefault(require("./branding/twitterLogo.svg"));

var _twitterVerified = _interopRequireDefault(require("./branding/twitterVerified.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Card = _styledComponents.default.article.withConfig({
  displayName: "Tweet__Card",
  componentId: "sc-1x5hzyr-0"
})(["border:1px solid rgb(207,217,222);border-radius:12px;padding:12px 16px 4px;max-width:550px;font-size:16px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue';"]);

var BlockLink = _styledComponents.default.a.withConfig({
  displayName: "Tweet__BlockLink",
  componentId: "sc-1x5hzyr-1"
})(["color:#000000;text-decoration:none;&:hover{text-decoration:none;}"]);

var Header = _styledComponents.default.div.withConfig({
  displayName: "Tweet__Header",
  componentId: "sc-1x5hzyr-2"
})(["display:flex;align-items:center;"]);

var Avatar = _styledComponents.default.img.withConfig({
  displayName: "Tweet__Avatar",
  componentId: "sc-1x5hzyr-3"
})(["border-radius:50%;height:48px;width:48px;"]);

var UserInfo = _styledComponents.default.div.withConfig({
  displayName: "Tweet__UserInfo",
  componentId: "sc-1x5hzyr-4"
})(["min-width:0;flex-grow:1;margin-left:8px;display:flex;flex-direction:column;& > strong{font-weight:bold;display:flex;& > span{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}}& > span{color:rgb(83,100,113);}"]);

var TwitterLogo = _styledComponents.default.img.withConfig({
  displayName: "Tweet__TwitterLogo",
  componentId: "sc-1x5hzyr-5"
})(["height:24px;width:24px;align-self:flex-start;"]);

var Verified = _styledComponents.default.img.withConfig({
  displayName: "Tweet__Verified",
  componentId: "sc-1x5hzyr-6"
})(["align-self:flex-start;height:16px;width:16px;margin-left:4px;margin-right:12px;"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "Tweet__Content",
  componentId: "sc-1x5hzyr-7"
})(["margin:12px 0;font-size:19px;"]);

var Metadata = _styledComponents.default.div.withConfig({
  displayName: "Tweet__Metadata",
  componentId: "sc-1x5hzyr-8"
})(["color:rgb(83,100,113);"]);

var Divider = _styledComponents.default.hr.withConfig({
  displayName: "Tweet__Divider",
  componentId: "sc-1x5hzyr-9"
})(["margin:8px 0;border:none;height:1px;background-color:rgb(207,217,222);"]);

var Photo = _styledComponents.default.img.withConfig({
  displayName: "Tweet__Photo",
  componentId: "sc-1x5hzyr-10"
})(["max-width:100%;margin-bottom:12px;border-radius:16px;"]);

var Stats = _styledComponents.default.div.withConfig({
  displayName: "Tweet__Stats",
  componentId: "sc-1x5hzyr-11"
})(["display:flex;margin:8px 0;gap:24px;"]);

var Stat = _styledComponents.default.div.withConfig({
  displayName: "Tweet__Stat",
  componentId: "sc-1x5hzyr-12"
})(["display:flex;gap:8px;align-items:center;color:rgb(83,100,113);& > svg{height:24px;& > path{fill:none;stroke:rgb(83,100,113);stroke-width:5px;}}& > span{}"]); // Source: https://developer.twitter.com/en/docs/twitter-for-websites/web-intents/image-resources


var Reply = function Reply() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 72"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M41 31h-9V19c0-1.14-.647-2.183-1.668-2.688-1.022-.507-2.243-.39-3.15.302l-21 16C5.438 33.18 5 34.064 5 35s.437 1.82 1.182 2.387l21 16c.533.405 1.174.613 1.82.613.453 0 .908-.103 1.33-.312C31.354 53.183 32 52.14 32 51V39h9c5.514 0 10 4.486 10 10 0 2.21 1.79 4 4 4s4-1.79 4-4c0-9.925-8.075-18-18-18z"
  }));
};

var Like = function Like() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 72"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.723,12c-7.187,0-11.16,7.306-11.723,8.131C26.437,19.306,22.504,12,15.277,12C8.791,12,3.533,18.163,3.533,24.647 C3.533,39.964,21.891,55.907,27,56c5.109-0.093,23.467-16.036,23.467-31.353C50.467,18.163,45.209,12,38.723,12z"
  }));
};

var fetcher = function fetcher() {
  return fetch.apply(void 0, arguments).then(function (res) {
    return res.json();
  });
};

var parseDate = function parseDate(string) {
  if (!string) return [null, null];
  var date = new Date(string);
  var timeStr = date.toLocaleTimeString([], {
    timeStyle: "short"
  });
  var dateStr = date.toLocaleDateString([], {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  return [timeStr, dateStr];
};

var _Symbol = _styledComponents.default.span.withConfig({
  displayName: "Tweet___Symbol",
  componentId: "sc-1x5hzyr-13"
})(["color:rgb(27,149,224);"]);

var isolateContent = function isolateContent(data) {
  if (!data) return null;
  var tokens = data.text.split(" ");
  var elements = tokens.map(function (token) {
    if (token.startsWith("@") || token.startsWith("#")) {
      return /*#__PURE__*/_react.default.createElement(_Symbol, null, token);
    } else if (token.startsWith("https://")) {
      var matchingURLs = data.entities.urls.filter(function (url) {
        return url.url === token;
      });

      if (matchingURLs.length) {
        return /*#__PURE__*/_react.default.createElement(_Symbol, null, matchingURLs[0].display_url);
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, token);
    }
  });
  return elements.reduce(function (prev, curr) {
    return [prev, " ", curr];
  });
};

function Media(_ref) {
  var data = _ref.data;

  if (data !== null && data !== void 0 && data.photos) {
    return /*#__PURE__*/_react.default.createElement(Photo, {
      src: data.photos[0].url
    });
  }

  return null;
}

function Tweet(props) {
  var _data$user, _data$user2, _data$user3, _data$user4, _data$user5;

  var url = new URL(props.apiUrl);
  url.searchParams.append("tweet", props.id);
  url.searchParams.append("lang", props.lang || "en");

  var _useSWR = (0, _swr.default)(url, fetcher),
      data = _useSWR.data;

  var content = isolateContent(data);

  var _parseDate = parseDate(data === null || data === void 0 ? void 0 : data.created_at),
      _parseDate2 = _slicedToArray(_parseDate, 2),
      timeString = _parseDate2[0],
      dateString = _parseDate2[1];

  return /*#__PURE__*/_react.default.createElement(Card, {
    className: props.className,
    style: props.style
  }, /*#__PURE__*/_react.default.createElement(BlockLink, {
    href: "https://twitter.com/".concat(data === null || data === void 0 ? void 0 : (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.screen_name, "/status/").concat(props.id),
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(Avatar, {
    src: data === null || data === void 0 ? void 0 : (_data$user2 = data.user) === null || _data$user2 === void 0 ? void 0 : _data$user2.profile_image_url_https
  }), /*#__PURE__*/_react.default.createElement(UserInfo, null, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement("span", null, data === null || data === void 0 ? void 0 : (_data$user3 = data.user) === null || _data$user3 === void 0 ? void 0 : _data$user3.name), (data === null || data === void 0 ? void 0 : (_data$user4 = data.user) === null || _data$user4 === void 0 ? void 0 : _data$user4.verified) && /*#__PURE__*/_react.default.createElement(Verified, {
    src: _twitterVerified.default,
    alt: "Verified"
  })), /*#__PURE__*/_react.default.createElement("span", null, "@", data === null || data === void 0 ? void 0 : (_data$user5 = data.user) === null || _data$user5 === void 0 ? void 0 : _data$user5.screen_name)), /*#__PURE__*/_react.default.createElement(TwitterLogo, {
    src: _twitterLogo.default,
    alt: "Twitter logo"
  })), /*#__PURE__*/_react.default.createElement(Content, null, content), /*#__PURE__*/_react.default.createElement(Media, {
    data: data
  }), /*#__PURE__*/_react.default.createElement(Metadata, null, /*#__PURE__*/_react.default.createElement("span", null, timeString), /*#__PURE__*/_react.default.createElement("span", null, " \xB7 "), /*#__PURE__*/_react.default.createElement("span", null, dateString)), /*#__PURE__*/_react.default.createElement(Divider, null), /*#__PURE__*/_react.default.createElement(Stats, null, /*#__PURE__*/_react.default.createElement(Stat, null, /*#__PURE__*/_react.default.createElement(Reply, null), " ", /*#__PURE__*/_react.default.createElement("span", null, data === null || data === void 0 ? void 0 : data.conversation_count)), /*#__PURE__*/_react.default.createElement(Stat, null, /*#__PURE__*/_react.default.createElement(Like, null), " ", /*#__PURE__*/_react.default.createElement("span", null, data === null || data === void 0 ? void 0 : data.favorite_count)))));
}